<template>
  <div id="hotelDetail">
    <v-container class="section" grid-list-md text-xs-center>
      <v-layout class="text-xs-left" row wrap>
        <v-flex xs12 md4 mt-4>
          <v-navigation-drawer stateless value="true">
            <v-list>
              <!-- 沒有子目錄 -->
              <v-list-tile v-if="!item.isRoot && !item.rootTitle" v-for="(item, i) in hotelDetail" :key="i" @click="changeTab(item)">
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile>
              <!-- 主目錄 -->
              <v-list-group v-if="item.isRoot" no-action value="true" v-for="(item, i) in hotelDetail" :key="i">
                <v-list-tile slot="activator">
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile>
                <!-- 子目錄 -->
                <v-list-tile v-if="item.title === subItem.rootTitle" v-for="(subItem, i) in hotelDetail" :key="i" @click="changeTab(subItem)">
                  <v-list-tile-title v-text="subItem.title" />
                  <v-list-tile-action>
                    <v-icon v-text="subItem.icon" />
                  </v-list-tile-action>
                </v-list-tile>
              </v-list-group>
            </v-list>
          </v-navigation-drawer>
        </v-flex>
        <v-flex xs12 md8 mt-8>
          <!-- 沒有子目錄 -->
          <v-card v-if="currentTab === item.id" v-for="(item, i) in hotelDetail" :key="i" flat>
            <v-carousel hide-delimiters>
              <v-carousel-item v-for="img in item.img" :key="n" :src="`/cannan_api/images/${img}`" transition="fade" />
            </v-carousel>
            <v-card-text>
              <div class="subheading my-4" v-html="currentContent">
              </div>
            </v-card-text>
          </v-card>
          <!-- 子目錄 -->
          <div v-if="currentTab === item.id" v-for="(item, i) in hotelDetail" :key="i">
            <v-card v-if="currentTab === subItem.changeTab" v-for="(subItem, i) in item.subItems" :key="i" flat>
              <v-carousel hide-delimiters>
                <v-carousel-item v-for="img in item.img" :key="n" :src="`/cannan_api/images/${img}`" transition="fade" />
              </v-carousel>
              <v-card-text>
                <div class="subheading my-4" v-html="currentContent">
                  {{ currentContent }}
                </div>
              </v-card-text>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { WOW } from 'wowjs'

export default {
  data() {
    return {
      currentTab: 'one',
      currentContent: ''
    }
  },
  computed: mapGetters({
    hotelDetail: 'hotelDetail'
  }),
  created() {
    this.fetchData()
  },
  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      var wow = new WOW({
        live: false
      })
      wow.init()
    })
  },
  methods: {
    fetchData() {
      this.$store.dispatch('GetHotelDetail').then(resopnse => {
        // this.current_catelog = this.catelog.data[0]
      })
    },
    changeTab(item) {
      console.log(item)
      this.currentTab = item.id
      this.currentContent = item.content
    }
  }
}
</script>

